// Image.jsx
import React, { useState, useEffect } from "react";
import { imageApi } from "../../api/image"; // Adjust the import path as needed

const Images = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchImages();
  }, [page, searchTerm]);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const result = await imageApi.getImages(page, 20, searchTerm);

      if (result.success) {
        setPhotos(result.photos);
        setTotal(result.total);
        setError(null);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(1); // Reset to first page on new search
  };

  const handleLoadMore = () => {
    if (photos.length < total) {
      setPage((prev) => prev + 1);
    }
  };

  if (loading && page === 1) {
    return (
      <div className="flex items-center justify-center   bg-black text-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center   bg-black text-white">
        <div className="text-center">
          <p className="text-red-500 mb-4">Error: {error}</p>
          <button
            onClick={fetchImages}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* 3-Column Grid Layout */}
      <div className="grid grid-cols-3 gap-1 px-6 py-4">
        {photos.map((photo) => (
          <div
            key={photo._id}
            className="relative aspect-square overflow-hidden rounded-lg group cursor-pointer"
          >
            <img
              src={imageApi.getImageUrl(photo.img)}
              alt={photo.description || "Image"}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-300"
              loading="lazy"
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/300?text=No+Image";
              }}
            />
          </div>
        ))}
      </div>

      {/* Load More Button */}
      {photos.length > 0 && photos.length < total && (
        <div className="flex justify-center py-8">
          <button
            onClick={handleLoadMore}
            disabled={loading}
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}

      {/* No Results Message */}
      {photos.length === 0 && !loading && (
        <div className="text-center text-gray-500 py-20">
          <p className="text-lg">No images found</p>
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className="mt-2 text-blue-500 hover:underline"
            >
              Clear search
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Images;
